import { render, staticRenderFns } from "./InfoActionButton.vue?vue&type=template&id=2f3f47de&scoped=true"
import script from "./InfoActionButton.vue?vue&type=script&lang=js"
export * from "./InfoActionButton.vue?vue&type=script&lang=js"
import style0 from "./InfoActionButton.vue?vue&type=style&index=0&id=2f3f47de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3f47de",
  null
  
)

export default component.exports